/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Tab_HierarchyInputs */



/**
* | output |
* | --- |
* | "Hierarchy" |
*
* @param {Consumption_Tab_HierarchyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_tab_hierarchy = /** @type {((inputs?: Consumption_Tab_HierarchyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Tab_HierarchyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Hierarchy")
	return /** @type {LocalizedString} */ ("Hiérarchie")
});